import Vue from 'vue';
import Router from 'vue-router';
import SelectGame from './views/SelectGame.vue';
import AdminLogin from './views/AdminLogin.vue';
import Reports from './views/Reports.vue';
import Health from './views/Health.vue';
import FootbowlGame from './views/FootbowlGame.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: AdminLogin,
      meta: {
        hideNav: true,
        adminNav: true,
      },
    },
    {
      path: '/selectGame',
      name: 'selectGame',
      component: SelectGame,
      meta: {
        adminNav: true,
      },
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: {
        adminNav: true,
      },
    },
    {
      path: '/health',
      name: 'health',
      component: Health,
    },
    {
      path: '/footbowl/:center/lane/:lane',
      name: 'footbowl',
      component: FootbowlGame,
      meta: {
        hideNav: true,
      },
    },
    {
      path: '/footbowl/:gameId',
      name: 'footbowlById',
      component: FootbowlGame,
      meta: {
        hideNav: true,
      },
    },
  ],
});
